import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=21cafd2b&scoped=true&"
import script from "./CategoryButton.vue?vue&type=script&lang=js&"
export * from "./CategoryButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryButton.vue?vue&type=style&index=0&id=21cafd2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cafd2b",
  null
  
)

export default component.exports